import { ArrowRight } from 'lucide-react';
import './CTA.css';

export default function CTASection() {
  return (
    <section className="cta-section" id="cta" aria-labelledby="cta-heading">
      <div className="cta-body">
        <div>
          <span className="eyebrow">Ready to modernize?</span>
          <h2 id="cta-heading">Ready to Modernize Your Infrastructure?</h2>
          <p>Let VanByte Technologies help you move faster with secure, scalable cloud systems designed for the next era of business.</p>
        </div>
        <a className="button cta-button" href="mailto:hello@vanbyte.com">
          Start your consultation
          <ArrowRight size={18} className="button-icon" />
        </a>
      </div>
    </section>
  );
}
